// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"654e2ed7","988":"b65f1c1b"}[chunkId] + ".chunk.js";
};